import ReadyToTry from './ReadyToTry'

export default ReadyToTry
